import { useState, useEffect } from 'react';

const useWindowWidth = () => {
  const [width, setWidth] = useState(document.body.clientWidth);

  useEffect(() => {
    const updateWidth = () => setWidth(document.body.clientWidth);

    const observer = new MutationObserver(() => {
      updateWidth();
    });

    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return width;
};

export default useWindowWidth;
